import { Typography } from "@material-ui/core";
import { LocalShipping } from "@material-ui/icons";
import { useCallback } from "react";
import {
  Button,
  Datagrid,
  DateField,
  FunctionField,
  TextField,
  useTranslate,
} from "react-admin";
import { useHistory } from "react-router-dom";
import safetyAlerts from ".";
import resourceNames from "../../../common/data/resourceNames";
import { SafetyAlertListDto } from "../../../common/data/service-proxies";
import { DefaultProLogsList } from "../../common/list/DefaultProLogsList";
import { ProLogsEmpty } from "../../common/list/ProLogsEmpty";

interface ExpandProps {
  record?: SafetyAlertListDto;
}

const getIcon = (record?: SafetyAlertListDto) => {
  if (!record) {
    return;
  }

  if (!record.entityType) {
    return;
  }

  switch (record.entityType) {
    case "Vehicle":
      return <LocalShipping />;
    // TODO: Cases for driver, trailer, company
  }
};

const SafetyAlertDetails = ({ record }: ExpandProps) => {
  return (
    <div>
      <Typography>{record?.text}</Typography>
    </div>
  );
};

export const SafetyAlertsList = (props: any) => {
  const history = useHistory();
  const translate = useTranslate();
  const handleLinkClick = useCallback(
    (record?: SafetyAlertListDto) => {
      if (!record) {
        return;
      }

      if (!record.entityType) {
        return;
      }

      switch (record.entityType) {
        case "Vehicle":
          history.push(
            `/${resourceNames.ASSETS_MAINTENANCE_DASHBOARD}/${record.entityId}`
          );
          break;

        // TODO: Cases for driver, trailer, company
      }
    },
    [history]
  );

  return (
    <div className="content-container">
      <DefaultProLogsList
        title="resources.safety-alerts.name"
        bulkActionButtons={false}
        actions={false}
        empty={<ProLogsEmpty iconType={safetyAlerts.icon} />}
        {...props}
      >
        <Datagrid rowClick="expand" expand={<SafetyAlertDetails />}>
          <FunctionField<SafetyAlertListDto>
            render={(record) =>
              record?.entityId && record.entityType ? (
                <Button
                  label={record.entityName ?? "-"}
                  onClick={() => handleLinkClick(record)}
                >
                  {getIcon(record)}
                </Button>
              ) : null
            }
          />
          <DateField source="creationTime" sortable={false} showTime />
          <TextField source="subject" sortable={false} />
          <FunctionField<SafetyAlertListDto>
            source="messageReason"
            sortable={false}
            render={(record) => (
              <Typography variant="body2">
                {record?.entityName
                  ? translate(
                      `resources.admin-notifications.notificationTypes.${record.entityType}.${record.messageReason}`,
                      { _: record.messageReason }
                    )
                  : record?.messageReason}
              </Typography>
            )}
          />
        </Datagrid>
      </DefaultProLogsList>
    </div>
  );
};
